import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../../public/locales/en/translation.json';
import esTranslations from '../../public/locales/es/translation.json';
import { readLangCookie } from '../lib/langCookie';

// Translations are bundled into the JS at build time — same pattern as the
// consumer app (glpweb-main-container-mfe/src/i18n/i18n.ts) and the public
// site. No runtime HTTP fetch.
//
// Initial language: the shared `glp_lang` cookie (scoped to
// .grocerylistplus.com) so the choice carries across www / app / vendor.
const initialLang = readLangCookie() ?? 'en';

export const i18nInitPromise = i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
    },
    react: { useSuspense: false },
  });

void i18nInitPromise;

export default i18n;
